import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Enterprise Multi-Region AWS Infrastructure',
        projectDesc: 'Architected and deployed enterprise-scale AWS infrastructure across multiple regions with 24/7 high availability, disaster recovery, and automated failover capabilities using AWS CDK and Infrastructure as Code.',
        tags: ['AWS', 'CDK', 'Terraform', 'Kubernetes'],
        code: '',
        demo: '',
        image: six
    },
    {
        id: 2,
        projectName: 'Global CI/CD Platform',
        projectDesc: 'Built comprehensive CI/CD pipelines serving Fortune 500 companies and universities, reducing development cycles by 300% through strategic automation and streamlined deployment processes.',
        tags: ['AWS', 'Docker', 'Kubernetes', 'Python'],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 3,
        projectName: 'Enterprise DevOps Transformation',
        projectDesc: 'Led distributed DevOps initiatives across APAC regions, implementing secure, scalable solutions for mining, education, and insurance industries with integrated identity management and SSO.',
        tags: ['AWS', 'DevSecOps', 'SSO', 'Enterprise Architecture'],
        code: '',
        demo: '',
        image: eight
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/